export default "__VITE_ASSET__BIKdH4JW__"